import slice from "./clientContext.slice";

export const selectSlice = state => state[slice.name];

export const selectClientConfig = state => selectSlice(state).client;
